import AlbumsList from "./albums-list";

export default AlbumsList;
